import { MutableRefObject } from 'react';

import { css } from '@compiled/react';

import { wacToken } from '@/libraries/design/foundations';
import { useTheme } from '@/libraries/design/utils/dark-theme-provider';

import { NavAccountActions, NavAccountActionsProps } from './nav-account-actions';
import { NavCta, NavCtaProps } from './nav-cta';
import { NavSearchAction, NavSearchActionProps } from './nav-search-action';

export type NavUtilitiesProps = NavCtaProps &
	NavSearchActionProps &
	NavAccountActionsProps & {
		searchAndProfileRef: MutableRefObject<HTMLDivElement | null>;
		isDisplayDivider?: boolean;
	};

const dividerStyle = css({
	borderInlineStart: `1px solid ${wacToken('color.neutral.light300')}`,
	width: '1px',
	height: '24px',
	alignSelf: 'center',
});

const dividerDarkThemeStyle = css({
	borderInlineStartColor: wacToken('color.neutral.dark300'),
});

export const NavUtilities = ({
	searchAndProfileRef,
	isShowSearchButton = true,
	showAiBackground,
	setIsOpenSearch,
	isDisplayDivider = true,
	isShowAppSwitcher,
	isShowUserProfile,
	...ctaProps
}: NavUtilitiesProps) => {
	const { isDarkTheme } = useTheme();

	return (
		<div
			css={css({ display: 'flex', flexDirection: 'row', gap: '16px' })}
			ref={searchAndProfileRef}
		>
			<NavSearchAction
				isShowSearchButton={isShowSearchButton}
				showAiBackground={showAiBackground}
				setIsOpenSearch={setIsOpenSearch}
			/>
			{isShowSearchButton && isDisplayDivider ? (
				<div
					css={[dividerStyle, isDarkTheme && dividerDarkThemeStyle]}
					data-testid="nav-utilities-divider"
				/>
			) : null}
			<NavAccountActions
				isShowAppSwitcher={isShowAppSwitcher}
				isShowUserProfile={isShowUserProfile}
			/>
			<NavCta {...ctaProps} />
		</div>
	);
};
